import React from 'react';
import { Translation } from "react-i18next";
import { Link } from "react-router-dom";
import { toRoute, tValue } from "../../i18n";
import { useGetInformationIndexinformationQuery } from "../../services";
import Image from "../image";
import './style.scss';
import PATH_MATCHING from '../../pages/information/blogPathMatching/pathMatching';

const BlogList = () => {
  const { data, isLoading, isError } = useGetInformationIndexinformationQuery({ category: 3 })

  if (isLoading) {
    return <div>Loading ...</div>
  } else if (isError) {
    return <div>Error ...</div>
  } else if (!data) {
    return <div>No data ...</div>
  }


  const findMatchingPath = (itId) => {
    const urlPath = PATH_MATCHING.find(item => item.it_id === itId)?.path;
    return urlPath;
  };
  

  return (
    data.slice(0, 3).map((blog) => (
      <div className="col-md-4" key={blog.id}>
        <Link to={toRoute(`/blog/${findMatchingPath(blog.id)}`)}>
          <div className="group-description">
            <Image src={blog.thumbnail} alt={blog.thumbnail} className="d-block w-100" />
            <h2>{tValue(blog, 'name') || blog.name_th}</h2>
            <p className="description-blog">{tValue(blog, 'description') || blog.description_th}</p>
          </div>
        </Link>
      </div>
    ))
  )
}

class BlogFooter extends React.PureComponent {
  render() {
    return (
      <Translation ns={['translation', 'blog']}>
        {(t) => (
          <div className="blog-footer">
            <div className="container">
              <div className="row">
                <div className="col-12 mt-2 mt-md-0">
                  <h1>{t("blog:Interesting Articles")}</h1>
                </div>
              </div>

              <div className="row">
                <BlogList />
              </div>
            </div>
          </div>
        )}
      </Translation>
    );
  }
}

export default BlogFooter;
